import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyCreatedNotifyApproversProps extends BaseTemplateProps {
  request: {
    name: string
  }
  createdBy: {
    name: string
  }
}

export const ArConnectApiKeyCreatedNotifyApprovers: TemplateDefinition<ArConnectApiKeyCreatedNotifyApproversProps> =
  {
    renderParams: (props: ArConnectApiKeyCreatedNotifyApproversProps) => ({
      messageKey: 'notificationsDomain.templates.arConnectApiKeyCreatedNotifyApprovers',
      values: {
        apiKeyName: props?.request?.name,
        createdBy: props?.createdBy?.name,
      },
    }),

    getLink: (props: ArConnectApiKeyCreatedNotifyApproversProps): string =>
      `/app/admin/approvals-management/approval-requests-search?tool=connect_api_key`,
  }
